import {
    anltx_api_ab_set_url,
    homepage2_api_posts_url,
    homepage2_api_url,
    homepage_api_posts_url,
    homepage_api_url,
    homepage_checkout_url,
} from 'mk/urls/functions';
import {
    BrandDaysCampaignEntity,
    BrandDaysCampaignSchema,
    PostEntity,
    PostSchema,
    TopicEntity,
    TopicSchema,
} from 'mk2/apps/forum/schemas';
import { BazaarCounts } from 'mk2/apps/home/containers/Home/Home.reducers';
import {
    anltxAbSet,
    homeLoadApi,
    homeLoadPageApi,
    AnltxAbSetTriggerAction,
    ANLTX_AB_SET_TRIGGER,
    HomeCheckoutTriggerAction,
    HomeLoadNormalizedResponse,
    HomeLoadPageTriggerAction,
    HomeLoadTriggerAction,
    HOME_CHECKOUT_TRIGGER,
    HOME_LOAD_PAGE_TRIGGER,
    HOME_LOAD_TRIGGER,
} from 'mk2/apps/home/containers/Home2/Home2.actions';
import {
    EshopPillsSchema,
    HomeCounsellingEntity,
    HomeCounsellingSchema,
    HomePhotoblogPostEntity,
    HomePhotoblogPostSchema,
    HomePostEntity,
    HomePostSchema,
} from 'mk2/apps/home/schemas';
import { Count } from 'mk2/components/NotificationsBadge';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { mergeDenormalized } from 'mk2/helpers/denormalized';
import { getLogger } from 'mk2/logger';
import { getRequestDeviceMobile, getRequestUser } from 'mk2/reducers';
import { normalize } from 'normalizr';
import { parse } from 'query-string';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { NEW_HP } from '../Home2/Home2';


const logger = getLogger('home/Home.sagas');

const getHomepageAB = (state: any) => state.request?.homepageAB ?? null;

interface ApiResponseHomeLoad {
    body: {
        forum: { posts: PostEntity[] };
        brandDays: { posts: PostEntity[]; campaign: BrandDaysCampaignEntity };
        contests: { posts: PostEntity[]; topic: TopicEntity };
        photoblog: { posts: HomePhotoblogPostEntity[] };
        homepage: { posts: HomePostEntity[]; nextPage: number | null };
        counselling: { counsellings: HomeCounsellingEntity[] };
        bazaar: { counts: BazaarCounts };
        lastVisitCountFriends: Count;
        place: {
            id: number;
            name: string;
        } | null;
        entities: HomeLoadNormalizedResponse['entities'];
        result: HomeLoadNormalizedResponse['result'];
    };
}

function* load({ currentUrl, page, fromPage, xhr }: HomeLoadTriggerAction & XHRAction) {
    const requestUser: any = yield select(getRequestUser);
    const homepageAB: string | null = yield select(getHomepageAB);
    const isAuthed = !!requestUser && !!requestUser.id;

    if (isAuthed && (homepageAB === NEW_HP)) {
        const isMobile = yield select(getRequestDeviceMobile);
        const query = parse(currentUrl.search);  // TODO: unused, consider to remove
        const brandDaysCampaign = query.with_brand_days_campaign as string;
        yield put(homeLoadApi.request(brandDaysCampaign, page, fromPage));

        try {
            const response: ApiResponseHomeLoad = yield call(() =>
                xhr.get(homepage2_api_url(), {
                    mobile: isMobile,
                    brandDays: brandDaysCampaign,
                    page,
                    fromPage,
                }),
            );

            const { entities, result, ...restResponse } = response.body;

            // TODO: Denormalize remaining entities on server
            const normalizedResponse: HomeLoadNormalizedResponse = normalize(restResponse, {
                forum: { posts: [PostSchema] },
                brandDays: { posts: [PostSchema], campaign: BrandDaysCampaignSchema },
                contests: { posts: [PostSchema], topic: TopicSchema },
                photoblog: { posts: [HomePhotoblogPostSchema] },
                homepage: { posts: [HomePostSchema] },
                counselling: { counsellings: [HomeCounsellingSchema] },
                eshopPills: {eshopPills: [EshopPillsSchema]},
            });

            // TODO: Remove when all entities will be normalized on server
            const mergedResponse = mergeDenormalized(normalizedResponse, {
                entities,
                result,
            });

            yield put(homeLoadApi.success(page, fromPage, mergedResponse));
        } catch (error) {
            yield handleXHRGetErrorSaga(error as XHRGetError, logger);
            yield put(homeLoadApi.failure(page, fromPage, normalizeError(error)));
        }
    } else {

        const isMobile = yield select(getRequestDeviceMobile);
        const query = parse(currentUrl.search);
        const brandDaysCampaign = query.with_brand_days_campaign as string;
        yield put(homeLoadApi.request(brandDaysCampaign, 1, 1));

        try {
            const response: ApiResponseHomeLoad = yield call(() =>
                xhr.get(homepage_api_url(), { mobile: isMobile, brandDays: brandDaysCampaign }),
            );

            const { entities, result, ...restResponse } = response.body;

            // TODO: Denormalize remaining entities on server
            const normalizedResponse: HomeLoadNormalizedResponse = normalize(restResponse, {
                forum: { posts: [PostSchema] },
                brandDays: { posts: [PostSchema], campaign: BrandDaysCampaignSchema },
                contests: { posts: [PostSchema], topic: TopicSchema },
                photoblog: { posts: [HomePhotoblogPostSchema] },
                homepage: { posts: [HomePostSchema] },
                counselling: { counsellings: [HomeCounsellingSchema] },
                eshopPills: { eshopPills: [EshopPillsSchema] },
            });

            // TODO: Remove when all entities will be normalized on server
            const mergedResponse = mergeDenormalized(normalizedResponse, {
                entities,
                result,
            });

            yield put(homeLoadApi.success(1, 1, mergedResponse));
        } catch (error) {
            yield handleXHRGetErrorSaga(error as XHRGetError, logger);
            yield put(homeLoadApi.failure(normalizeError(error), 1, 1));
        }
    }
}

interface ApiResponseHomeLoadPage {
    body: {
        posts: HomePostEntity[];
        nextPage: number | null;
    };
}

interface ApiResponseHomeLoadPage2 {
    body: {
        homepage: { posts: HomePostEntity[]; nextPage: number | null };

        entities: HomeLoadNormalizedResponse['entities'];
        result: HomeLoadNormalizedResponse['result'];
    };
}


function* loadPage({ xhr, page }: HomeLoadPageTriggerAction & XHRAction) {
    const requestUser: any = yield select(getRequestUser);
    const homepageAB: string | null = yield select(getHomepageAB);
    const isAuthed = !!requestUser && !!requestUser.id;

    if (isAuthed && (homepageAB === NEW_HP)) {
            const isMobile = yield select(getRequestDeviceMobile);

            yield put(homeLoadPageApi.request(page));

            try {
                const response: ApiResponseHomeLoadPage2 = yield call(() =>
                    xhr.get(homepage2_api_posts_url(page), {
                        mobile: isMobile,
                    }),
                );

                const { entities, result, ...restResponse } = response.body;

                // TODO: Denormalize remaining entities on server
                const normalizedResponse: HomeLoadNormalizedResponse = normalize(restResponse, {
                    homepage: { posts: [HomePostSchema] },
                });

                // TODO: Remove when all entities will be normalized on server
                const mergedResponse = mergeDenormalized(normalizedResponse, {
                    entities,
                    result,
                });

                yield put(homeLoadPageApi.success(page, mergedResponse));
            } catch (error) {
                yield handleXHRGetErrorSaga(error as XHRGetError, logger);
                yield put(homeLoadPageApi.failure(page, normalizeError(error)));
            }
    } else {

        const isMobile = yield select(getRequestDeviceMobile);

        yield put(homeLoadPageApi.request(page));

        try {
            const response: ApiResponseHomeLoadPage = yield call(() =>
                xhr.get(homepage_api_posts_url(page), { mobile: isMobile }),
            );

            const normalizedResponse: HomeLoadNormalizedResponse = normalize(response.body, {
                posts: [HomePostSchema],
            });

            yield put(homeLoadPageApi.success(page, normalizedResponse));
        } catch (error) {
            yield handleXHRGetErrorSaga(error as XHRGetError, logger);
            yield put(homeLoadPageApi.failure(page, normalizeError(error)));
        }
    }
}

function* checkout({ xhr, data }: HomeCheckoutTriggerAction & XHRAction) {
    try {
        yield call(() =>
            xhr.post(homepage_checkout_url(), data),
        );
    } catch (error) {
        // pass
    }
}

interface ApiResponseAbSet {
  body: {
    feature: string;
    variant: string;
    user_id: number;
    status: 'updated';
  };
}

function* abSetSaga({ xhr, feature, variant }: AnltxAbSetTriggerAction & XHRAction) {
  try {
    const response: ApiResponseAbSet = yield call(() =>
      xhr.post(anltx_api_ab_set_url(), { feature, variant }),
    );

    yield put(anltxAbSet.success(response.body));

    // reload AFTER the variant has been changed
    yield call(() => window.location.reload());
  } catch (error) {
    yield handleXHRGetErrorSaga(error as XHRGetError, logger);
    yield put(anltxAbSet.failure(normalizeError(error)));
  }
}

export default function* root() {
    yield all([
        takeLatest(HOME_LOAD_TRIGGER, load),
        takeLatest(HOME_LOAD_PAGE_TRIGGER, loadPage),
        takeLatest(HOME_CHECKOUT_TRIGGER, checkout),
        takeLatest(ANLTX_AB_SET_TRIGGER, abSetSaga),
    ]);
}
